export const MANAGERS_CHIP_CONFIG = {
    manager_primary: {
        size: 'small',
        color: 'primary',
        label: 'Community Manager'
    },
    default: {
        size: 'small',
        variant: 'light',
        color: 'success',
        label: 'Operator'
    },
    rental_manager: {
        size: 'small',
        variant: 'light',
        color: 'info',
        label: 'Rental Manager'
    },
    employee: {
        size: 'small',
        variant: 'light',
        color: 'primary',
        label: 'Employee'
    },
    manager: {
        size: 'small',
        variant: 'light',
        color: 'primary',
        label: 'Org Manager'
    },
    virtual_guard: {
        size: 'small',
        variant: 'light',
        color: 'info',
        label: 'Virtual Guard'
    },
    guard: {
        size: 'small',
        variant: 'light',
        color: 'secondary',
        label: 'Guard'
    }
};

export function getChipConfig(type, primary) {
    if (type === 'manager' && primary) {
        return {
            ...MANAGERS_CHIP_CONFIG['manager_primary'],
            label: 'Community Manager'
        };
    }

    return {
        ...(MANAGERS_CHIP_CONFIG[type] || MANAGERS_CHIP_CONFIG['default'])
    };
}
